import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './AuthContext';
import ProtectedRoute from './ProtectedRoute';
import AdminPage from './AdminPages/AdminDashboard';
import DashBoard from './MainPage/DashBoard';
import HomePage from './MainPages/HomePage';
import OnboardPage from './MainPage/OnboardPage';
import SignInPage from './MainPage/SignInPage';
import TerminalPage from './MainPage/TerminalPage';
import CompetitionPage from './MainPages/CompetitionPage';
import MusicProgramLinks from './MainPages/MusicProgramLinks';
import PrivacyPolicy from './MainPages/PrivacyPolicy';
import ItineraryPage from './MainPage/ItineraryPage';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/Onboard" element={<OnboardPage />} />
          <Route path="/SignInTerminal" element={<SignInPage />} />
          <Route path="/TerminalPage" element={<TerminalPage />} />
          <Route path="/Admin" element={<AdminPage />} />
          <Route path="/Competition" element={<CompetitionPage />} />
          <Route path="/MusicProgram" element={<MusicProgramLinks />} />
          <Route path="/music-program" element={<MusicProgramLinks />} />
          <Route path="/itinerary" element={<ItineraryPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route
            path="/DashBoard"
            element={
              <ProtectedRoute>
                <DashBoard />
              </ProtectedRoute>
            }
          />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
